const STORAGE_KEY = 'alfa-ai:next-url';

export const NEXT_URL_PARAM = 'next';

const isSafeInternalPath = (url: string): boolean => /^\/(?!\/)/.test(url) && !url.includes('://');

export const saveNextUrl = (url: string): void => {
  if (!url || url === '/' || !isSafeInternalPath(url)) {
    return;
  }

  try {
    sessionStorage.setItem(STORAGE_KEY, url);
  } catch {
    // sessionStorage недоступен (приватный режим и т.п.) — next просто не сработает.
  }
};

export const consumeNextUrl = (): string | null => {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);

    if (value) {
      sessionStorage.removeItem(STORAGE_KEY);
    }

    return value;
  } catch {
    return null;
  }
};
